import { colors } from '@piconetworks/pkg-functions';
import { ThemeBlockContrastColor, FormBlockContrastColor } from './BlockContrastColor.js';
import PropertyType from '../Modifiers/PropertyType.js';

var makeBlockButtonContrastColor = function makeBlockButtonContrastColor(property) {
  var value = property.getCssVariableValue();
  if (value !== undefined) {
    var blockButtonContrastColor = colors.getContrastColor(value);
    return blockButtonContrastColor;
  }
};
var makeCssBlockButtonContrastColor = function makeCssBlockButtonContrastColor(property) {
  var color = makeBlockButtonContrastColor(property);
  if (color !== undefined) {
    return "background-color: " + color + ";";
  }
};
var ThemeBlockButtonContrastColor = new PropertyType({
  name: 'BlockButtonContrastColor',
  propertyFromApi: 'block-button-contrast-color',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return makeCssBlockButtonContrastColor(ThemeBlockContrastColor);
  },
  defaultValue: '#000000',
  isCompounded: true,
  selector: '.block > .btn',
  priority: 9,
  cssVariable: '--block-button-contrast-color',
  cssVariableFunction: function cssVariableFunction(value) {
    return makeBlockButtonContrastColor(ThemeBlockContrastColor);
  },
  convertToRgb: true
}, 'theme');
var FormBlockButtonContrastColor = new PropertyType({
  name: 'BlockButtonContrastColor',
  propertyFromApi: 'block-button-contrast-color',
  convertValueToCssPropertiesFunction: function convertValueToCssPropertiesFunction(value) {
    return makeCssBlockButtonContrastColor(FormBlockContrastColor);
  },
  defaultValue: '#000000',
  isCompounded: true,
  selector: '.block > .btn',
  priority: 10,
  cssVariable: '--block-button-contrast-color',
  cssVariableFunction: function cssVariableFunction(value) {
    return makeBlockButtonContrastColor(FormBlockContrastColor);
  },
  convertToRgb: true
}, 'form');

export { FormBlockButtonContrastColor, ThemeBlockButtonContrastColor };
//# sourceMappingURL=BlockButtonContrastColor.js.map
